/** "$6,450" or "$6,450.50": no cents unless the amount has them. */
export function formatMoney(amount: number, currency: string, locale?: string): string {
    const fractionDigits = Number.isInteger(amount) ? 0 : 2;
    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        }).format(amount);
    } catch {
        // An unknown currency code is caught at publish; don't break the render.
        return `${new Intl.NumberFormat(locale).format(amount)} ${currency}`;
    }
}

export type Progress = { percent: number; barPercent: number };

/** Percent of goal (can pass 100) and the bar width (capped at 100). */
export function progressOf(raised: number, goal: number): Progress {
    const percent = goal > 0 ? Math.floor((raised / goal) * 100) : 0;
    return {
        percent,
        barPercent: Math.min(100, Math.max(0, goal > 0 ? (raised / goal) * 100 : 0)),
    };
}
